import React, { useState, useEffect } from 'react';

function ImageGallery({ images, altText }) {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    setCurrent(0);
  }, [images]);
  if (!images || images.length === 0) return null;

  const goPrev = () =>
    setCurrent(prev => (prev === 0 ? images.length - 1 : prev - 1));
  const goNext = () =>
    setCurrent(prev => (prev === images.length - 1 ? 0 : prev + 1));

  return (
    <div>
      <div style={{ position: 'relative', width: '100%' }}>
        <img
          width="100%"
          src={images[current]}
          alt={altText || `Image ${current + 1}`}
        />
        {images.length > 1 && (
          <>
            <div className="flex justify-between items-center p-4">
              <div className="flex">
                <div
                  onClick={goPrev}
                  className="text-sm !border !border-solid border-gray-200 p-4 flex items-center justify-center cursor-pointer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </div>
                <div
                  onClick={goNext}
                  className="text-sm !border !border-solid border-gray-200 p-4 flex items-center justify-center cursor-pointer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ImageGallery;
